export default "__VITE_ASSET__eBtmI5ca__"